import { IconButton, TmdxAvatar } from '@ds';
import { ChatUserData } from '@features/components/Chat/components/ChatContent/Messages/CustomChannelHeader/ChannelMenu/interface';
import { memo } from 'react';
import { MdOutlineMessage } from 'react-icons/md';
import { TabEmptyState } from '../components/TabEmptyState';

export const ChatMembersTab = memo(
  ({ chatUsers, onMentionUser }: { chatUsers: ChatUserData[]; onMentionUser?: (user: ChatUserData) => void }) => {
    if (chatUsers.length === 0) {
      return <TabEmptyState message="No members yet" />;
    }

    return (
      <div className="flex flex-col gap-1">
        {chatUsers.map((member) => (
          <div key={member.id} className="flex items-center justify-between px-3 py-1 rounded-lg">
            <div className="flex items-center gap-2">
              <div className="relative shrink-0">
                <TmdxAvatar size="lg" src={member.image} name={member.name} fallbackInitials />
                {member.online && (
                  <span className="absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full bg-success-40 ring-2 ring-base-90" />
                )}
              </div>
              <div className="flex flex-col">
                <span className="text-m-m text-base-5">{member.name}</span>
                {/* Current role is not correct in user's metadata, so commenting out for now */}
                {/* {member.role && <span className="text-s-r text-base-20">{member.role}</span>} */}
              </div>
            </div>
            <IconButton
              size="xs"
              variant="light"
              startContent={<MdOutlineMessage size={18} />}
              aria-label={`Message ${member.name}`}
              onPress={() => onMentionUser?.(member)}
            />
          </div>
        ))}
      </div>
    );
  },
);
